import { render, staticRenderFns } from "./ThirdBaseClass.vue?vue&type=template&id=4df6ad18"
import script from "./ThirdBaseClass.vue?vue&type=script&lang=js"
export * from "./ThirdBaseClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports